export default "__VITE_ASSET__9ab4b16d__"